/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {GlobalSearchCriteriaService} from '../services/global-search-criteria.service';
import {SearchCriteriaInputTypeEnum} from '../configuration/search-criteria-input-type.enum';
import {GlobalSearchCriteriaModel} from '../models/global-search-criteria.model';

@Component({
    selector: 'app-input-criteria-type',
    templateUrl: './input-criteria-type.component.html',
    styleUrls: ['./input-criteria-type.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputCriteriaTypeComponent {
    @Input() searchCriteriaChange: EventEmitter<void>;
    @Input() globalSearchCriteriaModel: GlobalSearchCriteriaModel;
    @Output() searchCriteriaReset = new EventEmitter<void>();

    public searchCriteriaInputType = SearchCriteriaInputTypeEnum;

    constructor(private globalSearchCriteriaService: GlobalSearchCriteriaService) {
    }

    get criterionFilterInputType(): SearchCriteriaInputTypeEnum {
        return this.globalSearchCriteriaService.getSelectedSearchCriterionFilter()?.criterionFilterInputType
                ?? SearchCriteriaInputTypeEnum.INPUT_TEXT_NUMBER;
    }

    searchCriteriaResetHandler(): void {
        this.searchCriteriaReset.emit();
    }
}
